import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'in0016',
    ecrans: ['00-2']
});
